import { render, staticRenderFns } from "./IsChanged.vue?vue&type=template&id=19f96f77&scoped=true"
import script from "./IsChanged.vue?vue&type=script&lang=js"
export * from "./IsChanged.vue?vue&type=script&lang=js"
import style0 from "./IsChanged.vue?vue&type=style&index=0&id=19f96f77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19f96f77",
  null
  
)

export default component.exports